import { z } from 'zod';

// Variables de entorno expuestas al cliente. Vite sólo inyecta las que
// empiezan con VITE_; cualquier otra es undefined en el bundle final.
const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_API_URL: z.string().url(),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  // En el navegador no podemos hacer process.exit(); throw bloquea el bundle
  // load y el usuario ve el error en consola con detalle.

  console.error('Invalid environment variables:', parsed.error.flatten().fieldErrors);
  throw new Error('Invalid environment variables — ver console para detalle');
}

export const env = parsed.data;
export type Env = typeof env;
